import isString from 'lodash/isString';

export const mapCategories = (categories) => {
  return (categories || []).map(category => {
    return isString(category) ? category : category.id;
  });
}